import React from 'react'
import { useTranslation } from 'react-i18next'

import '../../css/unlockPin/QRCodeScannerCameraFeed.css'

type QRCodeScannerCameraFeedProps = {
  isScanning: boolean
  disable: boolean
  stopScanningFromVideoDevice: () => void
}

const QRCodeScannerCameraFeed: React.FC<QRCodeScannerCameraFeedProps> = ({
  isScanning,
  disable,
  stopScanningFromVideoDevice,
}) => {
  const { t } = useTranslation()
  return (
    <>
      {isScanning && (
        <div className="fullscreen-container">
          <div className="message">{t('unlock_pin_page.hold_camera')}</div>
          <video id="video" className="video" />
          <div className="cancel-button-container">
            <button
              className="btn responsive-button"
              disabled={disable}
              type="button"
              onClick={stopScanningFromVideoDevice}
            >
              {t('cancel')}
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default QRCodeScannerCameraFeed
